import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { defineCustomElements } from '@vhv/ui-kit/dist/loader';
import { AppModule } from './app/app.module';
import { Helper } from '@vhv/tarifrechner-common';
import { environment } from './environments/environment';

defineCustomElements(window);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));

console.debug = function(msg: any, instance?: Object) {
    if(!environment.production) {
        const instanceName = instance ? instance.constructor.name : "anonymous";
        if(msg.toString() === "[object Object]") {
            console.log("[" + Helper.dateTimeFormat(new Date()) + "][DEBUG] " + instanceName + " - @{See object in next line}");
            console.log(msg);
        } else {
            console.log("[" + Helper.dateTimeFormat(new Date()) + "][DEBUG] " + instanceName + " - " + msg);
        }
    }
};
